import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";
// const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/32. 베트남법인 1공장.f47da21016a9233ef431.jpg`;
import Factory1 from "../../assets/ForkLiftBusiness/베트남법인1공장.jpg";
import Item1 from "../../assets/ForkLiftBusiness/베트남법인1공장지게차.jpg";
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/33. 베트남법인 2공장.941377b6329ccddf6dc6.jpg`;
const Factory3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/34. 베트남법인 3공장.8ed6a0bf63b6b8cd7f48.jpg`;
// const Item1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/35 베트남법인 지게차.d6c37b18da517c7eb728.png`;
const ForkHeadOffice9 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">Fork Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">지역별법인</div>
                <div className="eng">Corporation by region</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"830px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOffice9">
                <div className="kor">베트남 1공장</div>
                <div className="eng">Vietnam Company1</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">클라크 미국본사</div>
                  <div className="eng">USA HQ</div>
                </Link>
              </S.NavItem>
<S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeMexico">
                  <div className="kor">멕시코 법인</div>
                  <div className="eng">Mexico Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice2">
                  <div className="kor">브라질 법인</div>
                  <div className="eng">Brazil Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice3">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa-Rica Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice4">
                  <div className="kor">독일 법인</div>
                  <div className="eng">Germany Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice5">
                  <div className="kor">프랑스 법인</div>
                  <div className="eng">France Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice6">
                  <div className="kor">호주 법인</div>
                  <div className="eng">Australia Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice7">
                  <div className="kor">싱가폴 법인</div>
                  <div className="eng">Singapore Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                            <Link to="/ForkLiftBusiness/HeadOfficeVnHq">
                                              <div className="kor">베트남 판매법인</div>
                                              <div className="eng">Vietnam Sales Company</div>
                                            </Link>
                                          </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice8">
                  <div className="kor">한국 법인 (부천)</div>
                  <div className="eng">Korea HQ (Bucheon)</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice9">
                  <div className="kor">베트남 1공장</div>
                  <div className="eng">Vietnam Company1</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice10">
                  <div className="kor">베트남 합자 법인</div>
                  <div className="eng">Vietnam JV Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice11">
                  <div className="kor">중국법인</div>
                  <div className="eng">China Company</div>
                </Link>
              </S.NavItem>
               <S.NavItem className="list-inner-item">
                                                                                                    <Link to="/ForkLiftBusiness/HeadOfficeIdnesia">
                                                                                                      <div className="kor">인도네시아 법인</div>
                                                                                                      <div className="eng">Indonesia Company</div>
                                                                                                    </Link>
                                                                                                  </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice12">
                  <div className="kor">한국 법인 (창원)</div>
                  <div className="eng">Korea Company (Changwon) </div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                                      <Link to="/ForkLiftBusiness/HeadOfficeRnd">
                                                                                        <div className="kor">글로벌 연구소</div>
                                                                                        <div className="eng">Global R&D Center</div>
                                                                                      </Link>
                                                                                    </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"베트남 법인"} titleeng={"CLARK Vietnam Company"} website={"https://clarkmhc.vn/"} />
            <div className="page-text">
              <h2>CLARK Material Handling Vietnam Co., Ltd. / CMHVN</h2>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img plus" alt="" />
              <div className="holder-name">
                <div className="kor">베트남 법인 / 1공장 / 완성차 조립 공장</div>
                <div className="eng">1st factory <br /> Forklift assembly factory</div>
              </div>
            </S.ImgHolderFullsize>
            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">베트남 2공장 / 지게차 부품 / 작업장치 제작공장</div>
                  <div className="eng">2nd factory <br /> Forklift parts production factory</div>
                </div>
              </S.ImgHolderHarf>
              <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">베트남 3공장 / 지게차 부품 / 바디 제작공장, 대형지게차 조립공장</div>
                  <div className="eng">3rd factory< br /> Forklift parts & heavy forklift production facotry</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요 판매 제품"} titleeng={"Major Production Products"} />
            <S.ImgHolderFlex className="center">
              <img src={Item1} className="fullsizeItem" alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요 이력"} titleeng={"Major History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">CLARK Material Handling Vietnam Co., Ltd. 법인개요</div>
                    <div className="eng">Company Profile of CLARK Material Handling Vietnam Co., Ltd.</div>
                  </div>
                  <div className="kor">설립일: 2018년 <br /></div>
                  <div className="eng">Establishment : 2018 <br /></div>
                </div>
              </div>
              <div className="kor">
                ※ 클라크 글로벌 종합 생산 공장 (완성차 및 부품)
                <br />
                ※ 중장기 15,000대 생산 케파 확보 예정
                <br />
                ※ 클라크 글로벌 종합 연구소 역할 / 글로벌 지게차 독자 개발 <br />
                및 부품 국산화 지원중
              </div>
              <div className="eng">
                ※ CLARK Global production factory (finished truck & parts) <br />
                ※ Plan to secure 12,000 units of production capacity in mid/long-term <br />
                ※ CLARK Global R&D Center / Deve
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ForkHeadOffice9;
